<template>
  <div class="scroll-region-wrapper">
    <slot />
    <div
      v-show="showScrollRegions"
      class="scroll-region top"
      @dragover="throttledScroll('up')"
    ></div>
    <div
      v-show="showScrollRegions"
      class="scroll-region bottom"
      @dragover="throttledScroll('down')"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { throttle } from 'lodash'

const props = defineProps<{ scrollContainerSelector: string }>()

const scroller = ref()
const showScrollRegions = ref(false)

// fiddle with these numbers until drag scrolling feels decent
const throttleTime = 10
const scrollAmount = 10

const throttledScroll = throttle(function (direction: 'up' | 'down') {
  if (!scroller.value) {
    scroller.value = document.querySelector(props.scrollContainerSelector)
  }

  const directionMultiplier = direction === 'up' ? -1 : 1
  const scrollAmountWithDirection = scrollAmount * directionMultiplier

  scroller.value.scroll({
    top: scroller.value.scrollTop + scrollAmountWithDirection,
    behavior: 'instant',
  })
}, throttleTime)

const onDragStartListener = () => {
  showScrollRegions.value = true
}

const onDragEndListener = () => {
  showScrollRegions.value = false
}

const onDropListener = () => {
  showScrollRegions.value = false
}

onMounted(() => {
  document.addEventListener('dragstart', onDragStartListener)
  document.addEventListener('dragend', onDragEndListener)
  document.addEventListener('drop', onDropListener)
})

onUnmounted(() => {
  document.removeEventListener('dragstart', onDragStartListener)
  document.removeEventListener('dragend', onDragEndListener)
  document.removeEventListener('drop', onDropListener)
})
</script>

<style scoped>
.scroll-region-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  overflow: hidden;
}

.scroll-region {
  width: 100%;
  z-index: 1;
  height: 30px;
}

.scroll-region.top {
  position: absolute;
  top: 0;
}

.scroll-region.bottom {
  position: sticky;
  bottom: 0;
}
</style>
